<template>
  <div
    class="flex flex-col items-center px-7 text-gray-600 text-center pb-4 w-full"
  >
    <div class="text-base mt-6 leading-[20px] font-medium">
      {{ t('product.show.dateRequestMenu.title') }}
    </div>
    <p class="text-xs mt-1.5 font-normal">
      {{ t('product.show.dateRequestMenu.description') }}
    </p>
    <div class="mt-8 flex gap-2">
      <Button
        color="primary"
        variant="outlined"
        data-test-id="date-picker-request-date-button"
        class="px-2 rounded-md grow text-xs flex items-center hover:bg-white hover:text-teal-900 relative group"
        @click="handleClick"
      >
        <PencilStrokeIcon
          class="w-5 h-5 transition-opacity duration-200 group-hover:opacity-100"
        />
        <PencilFilledIcon
          class="w-5 h-5 absolute transition-opacity duration-200 opacity-0 group-hover:opacity-100"
        />
        <span class="ml-1">{{
          t('product.show.dateRequestMenu.buttonLabel')
        }}</span>
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import PencilStrokeIcon from '~/assets/icons/event/pencil-stroke.svg?component'
import PencilFilledIcon from '~/assets/icons/event/pencil-fill.svg?component'

const emit = defineEmits<{
  'click:request-date': []
}>()

const { t } = useI18n()

const handleClick = () => {
  emit('click:request-date')
}
</script>
